// Chakra imports
import { Flex, Image, Text, Spinner, useColorModeValue } from '@chakra-ui/react';

import tracking from 'assets/img/tracking.png';

export default function Loading(props: {
    expediente: string;
}) {
    const textColor = useColorModeValue("navy.700", "white");

	return (
        <Flex flexDirection={{ base: 'column' }}>
            <Image src={tracking} h={{ base: '120px' }}  w={{ base: '209px' }}  mb='10px'/>
            <Flex >
                <Text color={textColor} fontSize='28px' fontWeight='700' mb='15px' lineHeight='100%'>
                    Detalle Documento de Transporte {props.expediente}
                </Text> 
            </Flex> 
            <Flex >
                <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                m='15px'
                color='blue.500'
                size='md'
                />
            </Flex>        
        </Flex>          
	);
}
